import { axios } from "../lib";
import * as endpoints from "./apiEndpoints";

class SupportTicketService {
  static loadSupportTickets(body) {
    const url = `${endpoints.BASE_URL}${endpoints.GET_SUPPORT_TICKETS}`;
    return axios.post(url, body).then((response) => response.data);
  }

  static getSupportTicket(id) {
    const url = `${endpoints.BASE_URL}${endpoints.GET_SUPPORT_TICKET}/${id}`;
    return axios.get(url).then((response) => response.data);
  }

  static updateSupportTicket(supportTicket) {
    const supportTicketId = supportTicket.id || supportTicket._id;

    const url = `${endpoints.BASE_URL}${endpoints.PUT_SUPPORT_TICKET}/${supportTicketId}`;
    const body = {
      supportTicket
    };

    return axios.put(url, body).then((response) => response.data);
  }

  static getDashboardMetrics() {
    const url = `${endpoints.BASE_URL}${endpoints.GET_SUPPORT_TICKETS}/dashboard`;
    return axios.get(url).then((res) => res.data);
  }

  static aggregateByStatus(params = {}) {
    const query = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      if (params[key]) {
        query.append(key, params[key]);
      }
    });

    const url = `${endpoints.BASE_URL}${
      endpoints.GET_SUPPORT_TICKETS
    }/status?${query.toString()}`;
    return axios.get(url).then((res) => res.data);
  }

  static getDashboardTickets(params = {}) {
    const query = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      if (params[key]) {
        query.append(key, params[key]);
      }
    });
    const url = `${endpoints.BASE_URL}${
      endpoints.GET_SUPPORT_TICKETS
    }/dashboard-tickets?${query.toString()}`;
    return axios.get(url).then((res) => res.data);
  }

  static loadTicketsByCustomerId(id) {
    const url = `${endpoints.BASE_URL}${endpoints.GET_SUPPORT_TICKETS}/customer/${id}`;
    return axios.get(url).then((response) => response.data);
  }

  static addAuditLog(id, auditLog) {
    const url = `${endpoints.BASE_URL}${endpoints.PUT_SUPPORT_TICKET}/${id}/audit-log`;
    const body = {
      auditLog
    };
    return axios.put(url, body).then((response) => response.data);
  }

  static getIsTicketResolvable(id) {
    const url = `${endpoints.BASE_URL}${endpoints.GET_SUPPORT_TICKETS}/resolvable/${id}`;
    return axios.post(url).then((response) => response.data);
  }
}

export default SupportTicketService;
